

import { Pie } from "react-chartjs-2";
import { diagramColors } from "./colors";
import { useTranslation } from "react-i18next";
import { Card, CardBody, CardHeader, CardTitle } from "reactstrap";

const formatData = (data, labels, colors) => {
    return {
        labels: labels,
        datasets: [
            {
                label: "My Dataset",
                data: data,
                backgroundColor: colors,
                hoverBackgroundColor: colors,
            },
        ],
    }
};

function PieChart({input, colorScheme='darkBlue', colors, title, icon, total}) {
    const { t } = useTranslation();
    if(!input)return null

    const values = Object.values(input)
    const labels = Object.keys(input).map(label => t(`reports.kpis.${label}`));

    if(!title){
        return <Pie data={formatData(values, labels, colors || diagramColors[colorScheme].palette)} />
    }

    console.log(input)

    return <Card className="card-chart">
            <CardHeader>
                <h5 className="card-category" style={{cursor:"default"}}>{title}</h5>
                <CardTitle tag="h3" style={{cursor:"default"}}>
                    <i className={`tim-icons ${icon} text-primary`} />{" "}
                    {total}
                </CardTitle>
            </CardHeader>
            <CardBody>
                <div className="chart-area">
                    <Pie 
                        data={formatData(values, labels, colors || diagramColors[colorScheme].palette)} 
                        options={{
                            maintainAspectRatio: false,
                            responsive: true,
                        }}
                        height={"100%"} 
                    />
                </div>
            </CardBody>
        </Card>
        
}

export default PieChart;
